import axios from '../../axios'
export default {
  namespaced: true,
  state: {
    elds: []
  },
  mutations: {
    ADD_ITEM(state, item) {
      state.elds.unshift(item)
    },
    SET_ELDS(state, elds) {
      state.elds = elds
    },
    REMOVE_ITEM(actions) {
      actions('fetchDataListItems')
    }
  },
  actions: {
    addItem(_, item) {
      return new Promise((resolve, reject) => {
        axios.post('eld/eld/',
          (item)
        )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    fetchDataListItems({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('eld/eld/')
          .then((response) => {
            commit('SET_ELDS', response.data.data.eld)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateItem(_, item) {
      return new Promise((resolve, reject) => {
        axios.put(`eld/eld/${item.id}/`,
          (item)
        )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    removeItem(_, itemId) {
      return new Promise((resolve, reject) => {
        axios.delete(`eld/eld/${itemId}/`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    }
  },
  getters: {}
}